module.exports = __webpack_public_path__ + "img/waypoint.0da5d336.gif";